import { AutocompleteResult, SearchAutocompleteSection } from "../types";

import { ListSectionItem } from "./ListSectionItem";

export interface ListItem {
  result: AutocompleteResult;
  section: SearchAutocompleteSection;
}

interface ListSectionProps {
  title: string;
  items: ListItem[];
  highlightedIndex: number;
  isMouseActive: boolean;
  onSelect: (item: ListItem) => void;
  highlightedRef: React.RefObject<HTMLButtonElement>;
  sectionIndex?: number;
  previousSectionsItemCount?: number;
}

export function ListSection({
  title,
  items,
  highlightedIndex,
  isMouseActive,
  onSelect,
  highlightedRef,
  previousSectionsItemCount = 0,
}: ListSectionProps) {
  return (
    <li>
      {title && <h3 className="mt-3 mb-1 ml-2 text-xs font-medium text-text-base-tertiary">{title}</h3>}
      {items.map((item, index) => (
        <ListSectionItem
          key={item.result.id}
          item={item}
          totalIndex={previousSectionsItemCount + index}
          highlightedIndex={highlightedIndex}
          isMouseActive={isMouseActive}
          onSelect={onSelect}
          highlightedRef={highlightedRef}
        />
      ))}
    </li>
  );
}
